// Copyright (c) 2022 by Move Closer

import { OrderData } from '../../../../contexts/orders/contracts/orders'

import { OrdersListItemProps } from './OrdersListItem.contracts'

export const translateOrderDataToOrderListItem = (order: OrderData): OrdersListItemProps => {
  return {
    item: {
      createdAt: order.createdAt,
      id: order.id,
      products: order.products,
      productsCost: order.productsCost,
      shippingCost: order.shippingCost,
      status: order.statusCode,
      statusDetails: order.statusDetails,
      totalCost: order.totalCost,
      updatedAt: order.updatedAt
    }
  }
}
